import { Logo } from "./Logo";
import { CandyCane } from "lucide-react";

export const Footer = ({ event }) => {
  return (
    <footer className="relative border-t border-white/10 bg-black px-4 sm:px-6 py-10 pb-28" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <Logo className="text-xl" />
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-600 max-w-md leading-relaxed flex items-start gap-2">
          <CandyCane size={14} className="text-blood shrink-0 mt-0.5" />
          HÖR on Tour — Halloween Edition, {event.city} 2026. Tickets sold exclusively via official partner platform. Lineup, venue &amp; timings subject to change.
        </p>
      </div>
    </footer>
  );
};
